import { TransportationList } from '@cemex-core/cmx-api/models/jobsite-std-lot/transportation-list';
import { MultipleStdLotSizeRes } from '@cemex-core/cmx-api/models/std-lot-size/multiple-std-lot-size-res';
import {
  OneClickStandardLotActions,
  OneClickStandardLotActionTypes,
} from '@ordersnproducts/modules/one-click-order/actions/one-click-standard-lot-actions';
import { OneClickProfileActions, OneClickProfileActionTypes } from './../actions/one-click-profile.actions';

export interface OneClickStandardLotState {
  loading: boolean;
  standardLotAvailable: MultipleStdLotSizeRes;
  selected: TransportationList;
}

export const initialState: OneClickStandardLotState = {
  loading: false,
  standardLotAvailable: null,
  selected: null,
};

export function reducer(
  state = initialState,
  action: OneClickStandardLotActions | OneClickProfileActions,
): OneClickStandardLotState {
  switch (action.type) {
    case OneClickStandardLotActionTypes.LOAD_STANDARD_LOT: {
      return {
        ...state,
        loading: true,
      } as OneClickStandardLotState;
    }
    case OneClickStandardLotActionTypes.LOAD_STANDARD_LOT_COMPLETE: {
      return {
        ...state,
        loading: false,
        standardLotAvailable: action.payload,
      } as OneClickStandardLotState;
    }
    case OneClickStandardLotActionTypes.SELECT_STANDARD_LOT: {
      return {
        ...state,
        selected: action.payload,
      } as OneClickStandardLotState;
    }
    case OneClickProfileActionTypes.RESET_BUILDER:
    case OneClickStandardLotActionTypes.RESET_STANDARD_LOT: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
